import React, { Component } from 'react';
import { Button, Modal, ModalBody, Row, Container, ModalFooter } from 'reactstrap';

import './ErroTamanhoArquivo.scss';

class ErroTamanhoArquivo extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			step: 'Default',
			activeIndex: 0,
		};
	}

	toggleModal = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

	renderModal() {
		return (
			<Modal
				id="modal-erro-tamanho-arquivo"
				centered={true}
				isOpen={this.state.isOpen}
				onClosed={this.handleModalClosed}
				backdrop="static">
				<ModalBody>
					<img alt="" title="Tamanho de arquvio excedido" src="../../img/erro-tamanho-arquivo.svg" />
					<p>
						Documentos excederam o tamanho suportado.
						<small>O limite de envio é de 500 mb. Separe os arquivos e envie em partes.</small>
					</p>
				</ModalBody>
				<ModalFooter>
					<Container>
						<Row className="justify-content-center">
							<Button color="info" onClick={() => this.closeModal()}>
								Ok, entendi
							</Button>
						</Row>
					</Container>
				</ModalFooter>
			</Modal>
		);
	}

	render = () => this.renderModal();
}

export default ErroTamanhoArquivo;
